export enum CameFrom {
  analytics = "analytics",
  boards = "boards"
}